import React, { useState, useEffect, useContext } from 'react';
import FullCard from '../../../../../components/Card/FullCard';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import axios from '../../../../../api/axios';
import Progressbar from '../../../../../components/Progress/Progressbar';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import store from '../../../../../store';
import useTitle from 'hooks/useTitle';
import { NULL } from 'sass';
import { FormHelperText, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  driversSettings: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
}));

const Drivers = ({ config }) => {
  useTitle('تنظیمات رانندگان');
  const classes = useStyles();
  const [settings, setSettings] = useState({
    driverInformSMSTime: 240,
    driversAllowedToSetInterests: false,
    driverInformSMSTime: 15,
  });
  const [loading, setLoading] = useState(false);
  const { showMessage, showError } = useContext(store);

  const fetchDriverSettings = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`/api/v1/admin/settings/driver`);
      setSettings(data?.settings || null);
      if (!data) {
        return showError('خطایی در بارگیری تنظیمات، لطفا مجددا امتحان کنید.');
      }
    } catch (error) {
      console.error(error);
      showError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckBoxChanged = (e) => {
    const { checked, name } = e.target;
    setSettings({ ...settings, [name]: checked });
  };
  function handleChangeTextField(e) {
    const { name, value } = e.target;
    setSettings({ ...settings, [name]: value });
  }

  const saveSettings = async () => {
    try {
      await axios.put(`/api/v1/admin/settings`, {
        settings,
        section: 'driver',
      });
      showMessage('تنظیمات با موفقیت ذخیره شد.');
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDriverSettings();
  }, []);

  return (
    <FullCard title={config.name} category="کلیه تنظیمات مربوط به رانندگان">
      {loading ? (
        <Progressbar />
      ) : (
        <div className={classes.driversSettings}>
          <FormControlLabel
            className="col-12"
            control={
              <Checkbox
                checked={settings?.driversAllowedToSetInterests}
                onChange={handleCheckBoxChanged}
                name="driversAllowedToSetInterests"
              />
            }
            label="اجازه به رانندگان برای یافتن بارها بر اساس مسیرهای مورد علاقه"
          />
          <div className="col-12 col-lg-4">
            <FormHelperText>
              مدت زمان انتظار به دقیقه جهت ارسال پیامک مناقصه برای یک راننده و
              شهر مقصد یکسان:
            </FormHelperText>
            <TextField
              value={settings?.driverInformSMSTime}
              onChange={handleChangeTextField}
              name="driverInformSMSTime"
              fullWidth
              type="number"
              variant="outlined"
            />
          </div>
          <div className="col-12 col-lg-4">
            <FormHelperText>
              مدت زمان قفل راننده جهت ارسال پیشنهاد مناقصه به دقیقه:
            </FormHelperText>
            <TextField
              value={settings?.driverBidLockMinutes}
              onChange={handleChangeTextField}
              name="driverBidLockMinutes"
              fullWidth
              type="number"
              variant="outlined"
            />
          </div>

          <Button
            className="col-12 col-lg-4"
            onClick={saveSettings}
            size="large"
            color="secondary"
            variant="contained"
            disabled={
              loading ||
              !settings?.driverInformSMSTime ||
              settings.driverInformSMSTime < 0
            }
          >
            ذخیره
          </Button>
        </div>
      )}
    </FullCard>
  );
};

export default Drivers;
